<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="440" persistent>
      <v-card class="convenio-card" elevation="12">

        <!-- Header con gradiente -->
        <div class="convenio-header">
          <!-- Círculos decorativos de fondo -->
          <div class="convenio-deco convenio-deco--1"></div>
          <div class="convenio-deco convenio-deco--2"></div>

          <div class="convenio-icon-wrap">
            <v-icon size="38" color="white">mdi-handshake</v-icon>
          </div>
          <div class="white--text mt-3">
            <div class="text-h6 font-weight-bold">Bienvenido/a</div>
            <div class="caption mt-1" style="opacity:0.82; line-height:1.4">
              Elige la institución con la que vas a trabajar hoy
            </div>
          </div>
        </div>

        <!-- Cuerpo -->
        <v-card-text class="px-6 pt-5 pb-4 mb-4">
          <div class="convenio-select-label mb-2">
            <v-icon small color="blue darken-3" class="mr-1">mdi-office-building-outline</v-icon>
            Institución de convenio
          </div>

          <v-select
            v-model="$store.state.convenio"
            :items="convenios"
            :loading="loading"
            item-text="nombre"
            item-value="id"
            label="Selecciona una institución"
            outlined
            dense
            prepend-inner-icon="mdi-domain"
            placeholder="Seleccione..."
            return-object
            hide-details="auto"
          ></v-select>

          <v-alert
            v-if="msg"
            type="error"
            dense
            text
            border="left"
            class="mt-3 mb-0 caption">
            {{ msg }}
          </v-alert>
        </v-card-text>

        <!-- Pie -->
        <v-card-actions class="px-6 pt-3 pb-14">
          <div class="caption grey--text">
            <v-icon x-small color="grey" class="mr-1">mdi-information-outline</v-icon>
            Puedes cambiarlo desde la barra superior
          </div>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-3"
            dark
            rounded
            depressed
            min-width="130"
            @click="cerrar()">
            <v-icon small left>mdi-check-circle-outline</v-icon>
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Clave ref="xclavecita"/>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Clave from './AModalClaveChange.vue'

  export default {
    data() {
      return {
        loading: true,
        dialog: false,
        msg: '',
        convenios: [],
      };
    },
    components:{
      Clave
    },
    methods: {
      openmodal() {
        this.msg = '';
        this.dialog = true;
      },
      setUniversidades(conves) {
        //this.dialog = true;
        this.convenios = conves;
        this.loading = false;
      },
      async getConveniosUniversidades() {
        let vue = this;
        vue.loading = true;
        const sql = gql`query{ getInstituciones(estado:true){id,nombre,tipo,convenio,abreviatura} }`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          let conves = data.getInstituciones;
          conves = conves.filter(x=>{return x.convenio});
          this.convenios = conves;
          vue.loading = false;
        });
      },
      cerrar() {
        if (this.$store.state.convenio) {
          this.dialog = !this.dialog;
        } else {
          this.msg = 'Debes seleccionar una institucion';
        }
      },
    },
  };
</script>

<style>
.convenio-card {
  overflow: hidden;
  border-radius: 16px !important;
}

/* ── Header degradado ── */
.convenio-header {
  position: relative;
  background: linear-gradient(135deg, #0d47a1 0%, #1565c0 55%, #1e88e5 100%);
  padding: 36px 24px 28px;
  text-align: center;
  overflow: hidden;
}

/* Círculos decorativos */
.convenio-deco {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.07);
}
.convenio-deco--1 {
  width: 160px;
  height: 160px;
  top: -60px;
  right: -40px;
}
.convenio-deco--2 {
  width: 100px;
  height: 100px;
  bottom: -40px;
  left: -25px;
}

/* Ícono central */
.convenio-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 68px;
  height: 68px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(4px);
  margin-bottom: 4px;
}

/* Etiqueta del select */
.convenio-select-label {
  font-size: 12px;
  font-weight: 600;
  color: #1565c0;
  letter-spacing: 0.3px;
}
</style>
